export default {"src":"/_next/static/media/badge-google-ru.0b52a196.svg","height":41,"width":135,"blurWidth":0,"blurHeight":0};